import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GenericComponentsModule } from '@helios/generic-components'
import {
  NgbDropdownModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import {
  AutofocusModule,
  ButtonModule,
  InlineEditModule,
  NfFormsModule,
  RadioModule,
  SearchModule,
  ToggleModule,
} from '@northfork/ng-basics'
import { CreateNewFilterGroupModalComponent } from './components/filter-groups/create-new-filter-group-modal/create-new-filter-group-modal.component'
import { CreateNewFilterGroupModalService } from './components/filter-groups/create-new-filter-group-modal/create-new-filter-group-modal.service'
import { DeleteFilterGroupConfirmationModalComponent } from './components/filter-groups/delete-filter-group-confirmation-modal/delete-filter-group-confirmation-modal.component'
import { DeleteFilterGroupConfirmationModalService } from './components/filter-groups/delete-filter-group-confirmation-modal/delete-filter-group-confirmation-modal.service'
import { FilterGroupCardComponent } from './components/filter-groups/filter-group-card/filter-group-card.component'
import { FilterGroupImportButtonComponent } from './components/filter-groups/filter-group-import-button/filter-group-import-button.component'
import { FilterGroupsToolPanelComponent } from './components/filter-groups/filter-groups-tool-panel/filter-groups-tool-panel.component'
import { BulkDialogSortWarningModalComponent } from './components/modals/bulk-dialog-sort-warning-modal/bulk-dialog-sort-warning-modal.component'
import { BulkDialogSortWarningModalService } from './components/modals/bulk-dialog-sort-warning-modal/bulk-dialog-sort-warning-modal.service'
import { UpdateDescriptionModalComponent } from './components/modals/update-description-modal/update-description-modal.component'
import { UpdateDescriptionModalService } from './components/modals/update-description-modal/update-description-modal.service'
import { UserPreferencesDrawerComponent } from './components/user-preferences-drawer/user-preferences-drawer.component'
import { CreateNewWorkspaceModalComponent } from './components/workspace/create-new-workspace-modal/create-new-workspace-modal.component'
import { CreateNewWorkspaceModalService } from './components/workspace/create-new-workspace-modal/create-new-workspace-modal.service'
import { DeleteWorkspaceConfirmationComponent } from './components/workspace/delete-workspace-confirmation/delete-workspace-confirmation.component'
import { DeleteWorkspaceConfirmationService } from './components/workspace/delete-workspace-confirmation/delete-workspace-confirmation.service'
import { WorkspaceCardComponent } from './components/workspace/workspace-card/workspace-card.component'
import { WorkspaceCategoryComponent } from './components/workspace/workspace-catalog/workspace-catagory/workspace-category.component'
import { WorkspaceCatalogComponent } from './components/workspace/workspace-catalog/workspace-catalog.component'
import { WorkspaceCreateFromButtonComponent } from './components/workspace/workspace-catalog/workspace-create-from-button/workspace-create-from-button.component'
import { FilterGroupService } from './services/filter-group.service'
import { HttpFilterGroupService } from './services/http/http-filter-group.service'
import { HttpWorkspaceService } from './services/http/http-workspace-service'
import { KeyValueUiStorageService } from './services/key-value-ui-storage.service'
import { LocalWorkspaceService } from './services/local-storage/local-workspace-service'
import { UiStorageService } from './services/ui-storage.service'
import { WorkspaceDelegateService } from './services/workspace-delegate.service'
import { WorkspaceGridSavedViewService } from './services/workspace-grid-saved-view.service'
import { WorkspaceStoreLoaderService } from './services/workspace-store-loader.service'
import { WorkspaceUpdateListenerService } from './services/workspace-update-listener.service'
import { WorkspaceService } from './services/workspace.service'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    NfFormsModule,
    NgbDropdownModule,
    InlineEditModule,
    FormsModule,
    NgbTooltipModule,
    NgbPopoverModule,
    AutofocusModule,
    SearchModule,
    RadioModule,
    ToggleModule,
    GenericComponentsModule,
  ],
  declarations: [
    WorkspaceCardComponent,
    WorkspaceCatalogComponent,
    WorkspaceCategoryComponent,
    WorkspaceCreateFromButtonComponent,
    DeleteFilterGroupConfirmationModalComponent,
    DeleteWorkspaceConfirmationComponent,
    FilterGroupsToolPanelComponent,
    FilterGroupCardComponent,
    CreateNewWorkspaceModalComponent,
    UpdateDescriptionModalComponent,
    BulkDialogSortWarningModalComponent,
    CreateNewFilterGroupModalComponent,
    FilterGroupImportButtonComponent,
    UserPreferencesDrawerComponent,
  ],
  exports: [
    WorkspaceCatalogComponent,
    FilterGroupsToolPanelComponent,
    UserPreferencesDrawerComponent,
  ],
  providers: [
    { provide: WorkspaceService, useExisting: WorkspaceDelegateService },
    { provide: FilterGroupService, useClass: HttpFilterGroupService },
    DeleteFilterGroupConfirmationModalService,
    WorkspaceStoreLoaderService,
    WorkspaceUpdateListenerService,
    WorkspaceGridSavedViewService,
    CreateNewWorkspaceModalService,
    UpdateDescriptionModalService,
    BulkDialogSortWarningModalService,
    DeleteWorkspaceConfirmationService,
    CreateNewFilterGroupModalService,
    HttpWorkspaceService,
    LocalWorkspaceService,
    WorkspaceDelegateService,
    UiStorageService,
    KeyValueUiStorageService,
  ],
})
export class UserPreferencesModule {}
